/**
 * FH-A11Y batch 26 (2026-10-04): keyboard and screen reader fixes that change nothing on screen.
 *   A. Search pop-up (Globo): arrow keys work the instant results appear; Tab moves between the search box
 *      and Close; the pop-up is a named dialog; the number of results (or "no results") is read out; closing
 *      it also closes the theme's own search bar underneath, so one Escape is enough.
 *   C. Phone menu: the groups that expand (Rugs, Accessories, About) are buttons and work with Space.
 *   D. Chat: opening it moves focus into the chat, the launcher says whether the chat is open, and focus goes
 *      back to the launcher when the chat closes.
 *   E. Desktop menu: submenu lists hold only list items; pictures that repeat the link text next to them are
 *      silent; Escape closes a submenu that was opened by hovering.
 *   F. Product page: choosing a size that is out of stock is read out.
 *   G. Blog articles: the article title is the level-one heading; prices in product cards are not headings.
 *   H. Gift card "Send as a gift" pop-up: named dialog, focus moves in and stays in, Escape closes it, focus
 *      goes back to the button.
 * Rollback: remove the batch 26 line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch26) return;
  window.__fhA11yBatch26 = true;

  function setAttr(el, n, v) { if (el && el.getAttribute(n) !== v) el.setAttribute(n, v); }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function say(msg, delay) { if (typeof window.fhA11yAnnounce === 'function') window.fhA11yAnnounce(msg, delay || 250); }
  function focus(el) { if (el) { try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) {} } } }
  function shown(el) { return !!(el && el.getClientRects().length); }
  function safe(fn) { return function () { try { return fn.apply(this, arguments); } catch (e) {} }; }

  /* ---------- A. Search pop-up ---------- */
  var sPop = null, sObs = null, sTimer = 0, sLast = '';
  function searchToggle() { return document.querySelector('header summary.header__icon--search'); }
  function markOptions(p) {
    var o = p.querySelectorAll('#gl-search-listbox a[role="option"]:not(.gl-focusable-item)');
    for (var i = 0; i < o.length; i++) o[i].classList.add('gl-focusable-item');
  }
  function announceResults() {
    sTimer = 0;
    var p = sPop;
    if (!p || !p.isConnected) return;
    var input = p.querySelector('#gl-d-searchbox-input');
    var q = input ? input.value.trim() : '';
    if (!q) { sLast = ''; return; }
    var opts = p.querySelectorAll('#gl-search-listbox a[role="option"]');
    var n = 0;
    for (var i = 0; i < opts.length; i++) if (!/^view all/i.test(txt(opts[i]))) n++;
    var none = /nothing found|no results/i.test(p.textContent || '');
    var msg;
    if (none) msg = 'No results found for ' + q + '.' + (n ? ' ' + n + (n === 1 ? ' suggested product is' : ' suggested products are') + ' shown instead.' : '');
    else if (!n) return;
    else msg = (n === 1 ? '1 product shown.' : n + ' products shown.') + ' Use the Down arrow key to move through the results.';
    var key = q + '|' + msg;
    if (key === sLast) return;
    sLast = key;
    say(msg, 300);
  }
  function searchKeys(e) {
    if (e.key !== 'Tab' || !sPop) return;
    var input = sPop.querySelector('#gl-d-searchbox-input');
    var close = sPop.querySelector('.gl-d-close-btn');
    var a = document.activeElement;
    if (!input || !close || (a !== input && a !== close)) return;
    e.preventDefault();
    e.stopPropagation();
    focus(a === input ? close : input);
  }
  function searchOpened(p) {
    if (sPop === p) return;
    sPop = p;
    sLast = '';
    setAttr(p, 'role', 'dialog');
    setAttr(p, 'aria-modal', 'true');
    setAttr(p, 'aria-label', 'Search');
    setAttr(searchToggle(), 'aria-expanded', 'true');
    markOptions(p);
    p.addEventListener('keydown', searchKeys, true);
    if (sObs) sObs.disconnect();
    sObs = new MutationObserver(function () {
      /* No delay here: the app ignores arrow keys until each result carries this class. */
      try { markOptions(p); } catch (e) {}
      clearTimeout(sTimer);
      sTimer = setTimeout(safe(announceResults), 900);
    });
    sObs.observe(p, { childList: true, subtree: true });
  }
  function searchClosed() {
    if (sObs) { sObs.disconnect(); sObs = null; }
    clearTimeout(sTimer);
    sPop = null;
    sLast = '';
    var toggle = searchToggle();
    setAttr(toggle, 'aria-expanded', 'false');
    /* The theme's own search bar opens underneath the app's pop-up. Close it too. */
    var dm = document.querySelector('details-modal.header__search');
    var det = dm && dm.querySelector('details');
    if (det && det.hasAttribute('open')) {
      if (typeof dm.close === 'function') dm.close(false);
      else { det.removeAttribute('open'); document.body.classList.remove('overflow-hidden'); }
      focus(toggle);
    }
  }
  function checkSearch() {
    var p = document.getElementById('glFilter-search-popup');
    if (p && p !== sPop) searchOpened(p);
    else if (!p && sPop) {
      /* Wait a moment in case the app is only redrawing the pop-up. */
      setTimeout(safe(function () { if (sPop && !document.getElementById('glFilter-search-popup')) searchClosed(); }), 150);
    }
  }

  /* ---------- C. Phone menu groups ---------- */
  function fixPhoneMenu() {
    var links = document.querySelectorAll('li.tmenu_item_mobile > a.tmenu_item_link[aria-expanded]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!/^javascript:/i.test(a.getAttribute('href') || '')) continue;
      setAttr(a, 'role', 'button');
      if (a.__fh26) continue;
      a.__fh26 = true;
      a.addEventListener('keydown', function (e) {
        if ((e.key !== ' ' && e.key !== 'Spacebar') || !e.isTrusted) return;
        e.preventDefault();
        this.click();
      });
    }
  }

  function startPhoneMenu() {
    /* The menu app fills the phone menu in after the page loads, and again when the menu opens. */
    [0, 1200, 3000, 6000].forEach(function (ms) { setTimeout(safe(fixPhoneMenu), ms); });
    var det = document.getElementById('Details-menu-drawer-container');
    if (det) det.addEventListener('toggle', function () { setTimeout(safe(fixPhoneMenu), 120); });
  }

  /* ---------- D. Chat ---------- */
  var chatBound = false, chatPoll = 0;
  function launcher() { return document.getElementById('freshdeskwidgetcontainer'); }
  function bindChat() {
    var w = window.fcWidget;
    if (chatBound || !w || typeof w.on !== 'function') return chatBound;
    chatBound = true;
    try {
      w.on('widget:opened', safe(function () {
        setAttr(launcher(), 'aria-expanded', 'true');
        setTimeout(safe(function () {
          var a = document.activeElement;
          if (a && a !== document.body && a !== launcher() && a.isConnected && shown(a)) return;
          var frame = document.querySelector('#fc_frame iframe');
          if (frame) focus(frame);
        }), 350);
      }));
      w.on('widget:closed', safe(function () {
        var l = launcher();
        setAttr(l, 'aria-expanded', 'false');
        setTimeout(safe(function () {
          var a = document.activeElement;
          var lost = !a || a === document.body || !a.isConnected || (a.tagName === 'IFRAME' && a.closest && a.closest('#fc_frame'));
          if (l && lost) focus(l);
        }), 250);
      }));
    } catch (e) {}
    return true;
  }
  function watchChat() {
    if (chatBound || chatPoll) return;
    var tries = 0;
    chatPoll = setInterval(function () {
      tries++;
      if (bindChat() || tries > 40) { clearInterval(chatPoll); chatPoll = 0; }
    }, 500);
  }
  function startChat() {
    var l = launcher();
    if (!l) return;
    if (!l.hasAttribute('aria-expanded')) l.setAttribute('aria-expanded', 'false');
    ['click', 'mouseover', 'focus', 'keydown'].forEach(function (t) { l.addEventListener(t, watchChat); });
    if (window.fcWidget) bindChat();
  }

  /* ---------- E. Desktop menu ---------- */
  var navTimer = 0;
  function fixSubmenus(nav) {
    var extra = nav.querySelectorAll('ul.tmenu_submenu > :not(li):not(script):not(template)');
    for (var i = 0; i < extra.length; i++) setAttr(extra[i], 'role', 'listitem');
    var imgs = nav.querySelectorAll('ul.tmenu_submenu a img[alt]');
    for (var k = 0; k < imgs.length; k++) {
      var alt = (imgs[k].getAttribute('alt') || '').trim().toLowerCase();
      if (!alt) continue;
      var t = txt(imgs[k].closest('a')).toLowerCase();
      if (t && t.indexOf(alt) !== -1) imgs[k].setAttribute('alt', '');
    }
  }
  function startMenu(tries) {
    var nav = document.querySelector('nav.tmenu_navbar');
    if (!nav) { if (tries > 0) setTimeout(function () { startMenu(tries - 1); }, 700); return; }
    safe(fixSubmenus)(nav);
    safe(fixPhoneMenu)();
    /* Submenus are added the first time they open. */
    new MutationObserver(function () {
      if (navTimer) return;
      navTimer = setTimeout(function () { navTimer = 0; safe(fixSubmenus)(nav); safe(fixPhoneMenu)(); }, 200);
    }).observe(nav, { childList: true, subtree: true });
  }
  function closeHoverMenus(e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelectorAll('.tmenu_navbar li.tmenu_item--root.tmenu_item_active');
    for (var i = 0; i < open.length; i++) {
      (function (li) {
        if (li.contains(document.activeElement)) return; /* opened by keyboard: the menu app closes it */
        li.dispatchEvent(new MouseEvent('mouseleave', { bubbles: false, cancelable: true, relatedTarget: document.body }));
        li.dispatchEvent(new MouseEvent('mouseout', { bubbles: true, cancelable: true, relatedTarget: document.body }));
        setTimeout(function () {
          if (!li.classList.contains('tmenu_item_active')) return;
          li.classList.remove('tmenu_item_active');
          setAttr(li.querySelector(':scope > a[aria-expanded]'), 'aria-expanded', 'false');
        }, 80);
      })(open[i]);
    }
  }

  /* ---------- F. Out-of-stock size ---------- */
  function onVariantChange(e) {
    var picker = e.target.closest && e.target.closest('variant-selects, variant-radios');
    if (!picker) return;
    setTimeout(safe(function () {
      var b = document.querySelector('product-form button.product-form__submit') || document.querySelector('button.product-form__submit');
      if (!b || !/out of stock/i.test(txt(b))) return;
      var parts = [];
      picker.querySelectorAll('select').forEach(function (s) { if (s.value) parts.push(s.value); });
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { if (r.value) parts.push(r.value); });
      var notify = shown(document.querySelector('.gBackInStock-Form-Content-Input'));
      say((parts.length ? parts.join(', ') + ' is' : 'This choice is') + ' out of stock.' +
        (notify ? ' You can ask to be emailed when it is available, in the form that follows.' : ''), 1200);
    }), 900);
  }

  /* ---------- G. Blog articles ---------- */
  function fixBlog() {
    if (!/^\/blogs\/[^/]+\/[^/]+/.test(location.pathname)) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    if (!main.querySelector('h1, [role="heading"][aria-level="1"]')) {
      var title = main.querySelector('.ecom-shopify__article--title-text');
      if (title) { setAttr(title, 'role', 'heading'); setAttr(title, 'aria-level', '1'); }
    }
    var heads = main.querySelectorAll('h4, h5, h6');
    for (var i = 0; i < heads.length; i++) {
      if (/^\s*\$\s?\d[\d,]*(\.\d{2})?\s*$/.test(heads[i].textContent || '')) setAttr(heads[i], 'role', 'presentation');
    }
  }

  /* ---------- H. Gift card "Send as a gift" pop-up ---------- */
  var gift = null, giftOpener = null;
  function giftFocusables(m) {
    return Array.prototype.filter.call(
      m.querySelectorAll('a[href],button,input,select,textarea,[tabindex]'),
      function (el) { return !el.disabled && el.tabIndex >= 0 && el.type !== 'hidden' && shown(el); }
    );
  }
  function giftKeys(e) {
    var m = gift;
    if (!m) return;
    if (e.key === 'Escape') {
      var close = m.querySelector('.gvl-popup__close');
      if (close) { e.preventDefault(); e.stopPropagation(); close.click(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var list = giftFocusables(m);
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1], a = document.activeElement;
    if (!m.contains(a)) { e.preventDefault(); focus(first); }
    else if (e.shiftKey && (a === first || a.tagName === 'H2')) { e.preventDefault(); focus(last); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); focus(first); }
  }
  function giftClosed() {
    document.removeEventListener('keydown', giftKeys, true);
    gift = null;
    var o = giftOpener;
    giftOpener = null;
    setTimeout(function () {
      var a = document.activeElement;
      if (o && o.isConnected && (!a || a === document.body || !a.isConnected || !shown(a))) focus(o);
    }, 80);
  }
  function giftOpened(m) {
    if (gift === m) return;
    gift = m;
    var a = document.activeElement;
    giftOpener = (a && a.closest && a.closest('#gvl-btn-send-gift-card, .gvl-btn--store')) || document.getElementById('gvl-btn-send-gift-card');
    var dialog = m.querySelector('.gvl-popup-dialog') || m;
    var title = m.querySelector('.gvl-popup__header h2') || m.querySelector('h2');
    if (title) {
      if (!title.id) title.id = 'fh-gvl-gift-title';
      setAttr(title, 'tabindex', '-1');
      setAttr(dialog, 'aria-labelledby', title.id);
    }
    setAttr(dialog, 'role', 'dialog');
    setAttr(dialog, 'aria-modal', 'true');
    setAttr(m.querySelector('.gvl-popup__close'), 'aria-label', 'Close');
    document.addEventListener('keydown', giftKeys, true);
    setTimeout(safe(function () {
      if (gift !== m || m.contains(document.activeElement)) return;
      focus(title || m.querySelector('.gvl-popup__close'));
    }), 150);
  }
  function checkGift() {
    /* The app keeps clicks on its button to itself, so watch the pop-up for its "open" state instead. */
    var m = document.getElementById('gvl-popup-gifting-module');
    if (!m || m.__fh26) return;
    m.__fh26 = true;
    new MutationObserver(safe(function () {
      if (m.classList.contains('open')) giftOpened(m);
      else if (gift === m) giftClosed();
    })).observe(m, { attributes: true, attributeFilter: ['class'] });
    if (m.classList.contains('open')) giftOpened(m);
  }

  /* ---------- start ---------- */
  function start() {
    safe(checkSearch)();
    safe(checkGift)();
    /* The search and gift pop-ups are added at the end of the page. Direct children only. */
    new MutationObserver(function () { safe(checkSearch)(); safe(checkGift)(); }).observe(document.body, { childList: true });
    safe(startChat)();
    safe(startMenu)(8);
    safe(startPhoneMenu)();
    safe(fixBlog)();
    window.addEventListener('load', function () { safe(fixBlog)(); safe(fixPhoneMenu)(); safe(checkGift)(); });
    document.addEventListener('keydown', safe(closeHoverMenus));
    document.addEventListener('change', safe(onVariantChange), true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
